import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectRanchById, selectAllRanches } from '../selectors';
import { loadRanchList } from '../actions';

export default function useRanch(id) {
  const dispatch = useDispatch();
  const ranch = useSelector((state) => selectRanchById(state, id));
  useEffect(() => {
    dispatch(loadRanchList());
  }, [dispatch]);
  return ranch;
}

export function useRanchNames(ids) {
  const ranches = useSelector((state) => selectAllRanches(state));
  if (!ids || !ids.length) return {};
  const filteredRanches = ranches.filter((d) => ids.some((id) => id === d.id));
  return filteredRanches.reduce((a, ranch) => {
    a[ranch.id] = ranch.name;
    return a;
  }, {});
}
